module.exports = __webpack_public_path__ + "img/lc.10a44242.png";